module.exports = __webpack_public_path__ + "static/cf-reg-italic-edf388af1ade8619183fa70432853282.woff2";